/**
 * Given an InitiativeImpact enum code, returns an appropriate icon ID
 *
 * @param {String} impact - the InitiativeImpact value; could be the overall,
 * actual performance, or trend impact
 *
 * @param {Boolean} overall - true if the icon is for the "overall" impact;
 * false if it's the impact for actual performance or trend
 */
function impactIconId (impact, overall) {
	let suffix
	if (impact === 'positive' || impact === 'negative') {
		suffix = impact
	} else if (impact === 'none') {
		// #30286 The combined/"overall" icon at the top should be red/negative if there
		// is no impact, but individual sections (actual performance or trend) will
		// be a neutral warning if there is no impact
		suffix = overall ? 'negative' : 'warning'
	} else if (impact === 'mixed') {
		suffix = 'warning'
	} else if (impact === 'insufficient-data') {
		suffix = 'missing-data'
	}

	return 'impact-relation-' + suffix
}

export default impactIconId

impactIconId.__filename__ = 'related-items/impact-icon-id.js'
